import React, { useEffect } from "react";
import WineBehindGreenery from "../images/wine-behind-greenery.png";
import WineFlights from "../images/enoteca/wineflight.jpeg";
import Button from "../components/Button";
import Brownie from "../images/enoteca/Gelato Brownie.jpg";
import Flights from "../images/squares/flights.webp";
import Affogato from "../images/enoteca/Affogato2.jpg";
import Gelato from "../images/enoteca/GelatoX2.jpg";
import Fence from "../images/squares/fence.webp";
import WhiteBottle from "../images/squares/white-bottle.webp";
import WinesRow from "../images/wines-row.jpg";
import pizza from "../images/enoteca/pizza.jpg";
import piadine from "../images/enoteca/Piadine.jpg";
import tastingplate from "../images/enoteca/GourmetTasting.jpg";
import PizzaWine from "../images/pizza-wine.webp";
import ChrisFarrel from "../images/chris-farrel.webp";
import Sangrias from "../images/sangrias.webp";
import { tockSearchUrl } from "../utils/tock";
import ReservationFinder from "../components/ReservationFinder";

const TheEnoteca = () => {
  useEffect(() => {
    document.title = "Auburn Road - The Enoteca";
    return () => {
      document.title = "Auburn Road Vineyards";
    };
  }, []);

  return (
    <>
      <img
        src={WineBehindGreenery}
        className="corner-wine-behind-greenery"
        alt=""
      />
      <div className="container enoteca-page p-t-100">
        <section className="enoteca-hero">
          <p className="enoteca-hero__kicker">Our vineyard wine bar</p>
          <h1 className="huge-text-no-quote mb-3">The Enoteca</h1>
          <p className="enoteca-hero__intro">
            Auburn Road’s warm, sophisticated wine bar and outdoor café in the
            vines. Relax as our knowledgeable, friendly staff serve you
            eclectic, terroir-driven wines that belong on the table with the
            world’s best. A hidden gem, enjoy gourmet wood-fired pizza and live
            original music by global artists.
          </p>
          <p className="enoteca-hero__note">
            Wood-fired pizza, wine flights, and live music among the vines.
            Reservations recommended, especially on music nights.
          </p>
          <Button
            id="enoteca-main-reservation-click"
            className="m-t-20"
            type="secondary"
            href={tockSearchUrl()}
          >
            Make a reservation
          </Button>
        </section>

        <div className="enoteca-video">
          <iframe
            src="https://www.youtube.com/embed/wqIzi8XbSqs"
            title="YouTube video player"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>

        <section className="enoteca-block" aria-label="Reservations">
          <ReservationFinder />
        </section>

        <section className="enoteca-block" id="relax">
          <div className="enoteca-block__heading">
            <h2 className="huge-text-no-quote">Relax at the enoteca</h2>
            <p className="enoteca-block__intro">
              Settle in for pizza, tasting plates, and piadine, served in the
              vineyard.
            </p>
          </div>
          <img
            className="enoteca-feature"
            src={PizzaWine}
            alt="Pizza and wine at the Enoteca"
          />
          <div className="enoteca-gallery">
            <img className="enoteca-gallery__img" src={pizza} alt="Pizza" />
            <img
              className="enoteca-gallery__img"
              src={tastingplate}
              alt="Gourmet tasting plate"
            />
            <img className="enoteca-gallery__img" src={piadine} alt="Piadine" />
          </div>
        </section>

        <section className="enoteca-block enoteca-block--split" id="flights">
          <div className="enoteca-block__media">
            <img
              className="enoteca-photo"
              src={WineFlights}
              alt="Wine flights"
            />
          </div>
          <div className="enoteca-block__copy">
            <div className="enoteca-block__heading">
              <h2 className="huge-text-no-quote">
                …Or start
                <br />
                with a flight
              </h2>
            </div>
            <p className="enoteca-block__intro">
              If you want to do a self-guided tasting to see what feels right
              today…
            </p>
            <Button
              id="flights-reservation-click"
              type="secondary"
              href={tockSearchUrl()}
            >
              Make a reservation
            </Button>
          </div>
        </section>

        <section className="enoteca-block" id="music">
          <div className="enoteca-block__heading">
            <h2 className="huge-text-no-quote">Stay for some music</h2>
            <p className="enoteca-block__intro">
              …and hang out by the vineyards.
            </p>
          </div>
          <img
            className="enoteca-feature enoteca-feature--tall"
            src={ChrisFarrel}
            alt="Live music at the Vineyard Stage"
          />
          <div className="enoteca-gallery">
            <img
              className="enoteca-gallery__img"
              src={Fence}
              alt="Auburn Road fence"
            />
            <img
              className="enoteca-gallery__img"
              src={Flights}
              alt="Wine flights"
            />
            <img
              className="enoteca-gallery__img"
              src={WhiteBottle}
              alt="Auburn Road white wine bottle"
            />
          </div>
        </section>

        <section className="enoteca-block" id="brighten">
          <div className="enoteca-block__heading">
            <h2 className="huge-text-no-quote">…and then maybe</h2>
            <p className="enoteca-block__intro">
              Something to brighten you up…
            </p>
          </div>
          <img
            className="enoteca-feature"
            src={Sangrias}
            alt="Sangrias at the Enoteca"
          />
          <div className="enoteca-gallery">
            <img
              className="enoteca-gallery__img"
              src={Affogato}
              alt="Affogato"
            />
            <img className="enoteca-gallery__img" src={Gelato} alt="Gelato" />
            <img
              className="enoteca-gallery__img"
              src={Brownie}
              alt="Gelato brownie"
            />
          </div>
        </section>

        <section className="enoteca-block enoteca-block--finale" id="take-home">
          <div className="enoteca-block__heading enoteca-block__heading--center">
            <p className="enoteca-block__eyebrow">…and don’t forget to</p>
            <h2 className="huge-text-no-quote">
              Bring a little Auburn Road home with you
            </h2>
          </div>
          <img
            className="enoteca-photo enoteca-photo--wide"
            src={WinesRow}
            alt="Auburn Road wines"
          />
        </section>
      </div>
    </>
  );
};

export default TheEnoteca;
